export default __webpack_public_path__ + "static/Banner-783e2b7018265ed8e801bd4e1fadddbe.jpg";